import React from 'react'
import store from '../store'
import { Input, Tooltip } from 'hljd'
import mainStore from '@components/Main/store'
import styles from '../style.module.less'

// @observer
export default (activity_position, set_meal, can_show_tip) => [
  {
    title: '套餐',
    dataIndex: 'title',
    key: 'title',
    render: (text, record) => <div>{record.title ? record.title : '-'}</div>
  },
  {
    title: '套餐类型',
    dataIndex: 'kind',
    key: 'kind'
  },
  {
    title: '价格',
    dataIndex: 'price',
    key: 'price',
    render: (text, record) => (
      <div>
        <div>¥{record.actual_price}</div>
        {record.allow_earnest == '1' &&
          record.earnest_money && (
            <div style={{ color: '#ff5c5c' }}>
              定金：¥{record.earnest_money}
            </div>
          )}
      </div>
    )
  },
  {
    title: '活动价',
    dataIndex: 'sale_price',
    key: 'sale_price',
    render: (text, record, index) => {
      const { sale_price } = store.data[index]
      const min_price = activity_position.min_price
        ? +activity_position.min_price
        : 0
      const actual_price = +record.actual_price
      const hasError =
        min_price &&
        sale_price &&
        +min_price - (actual_price - sale_price) > 0 &&
        min_price < actual_price
      const canEdit =
        activity_position.set_meal.some(
          item => item.set_meal_id == record.id
        ) || record.version != '1'
      if (canEdit) {
        return <div>{text}</div>
      } else {
        return (
          <div className={!!hasError ? styles['has-error'] : ''}>
            <Tooltip
              visible={!!hasError && can_show_tip[index]}
              title={`价格需要下降${+min_price}元及以上才可以参加活动`}
              overlayStyle={{ width: '160px', zIndex: 99 }}
              getPopupContainer={triggerNode =>
                mainStore.contentMainDiv.current
              }
            >
              <Input
                value={text}
                style={{ width: '100px' }}
                onChange={store.changeFiled(index, record)}
              />
            </Tooltip>
          </div>
        )
      }
    },
    hidden: () => activity_position.is_set_sale_price != '1'
  },
  {
    title: '  售出数',
    dataIndex: 'sales_count',
    key: 'sales_count'
  },
  {
    title: '  收藏数',
    dataIndex: 'comments_count',
    key: 'comments_count'
  },
  {
    title: '  上架时间',
    dataIndex: 'published_time',
    key: 'published_time'
  }
]
